import { onReady } from '../lib/on-ready.js';

function initDropdown() {
    const dropdownButton = document.querySelector('#dropdown-button');
    if (!dropdownButton) {
        return;
    }

    dropdownButton.addEventListener('click', () => {
        const dropdownSelect = document.querySelector('#dropdown-select');
        if (dropdownSelect) {
            window.location = dropdownSelect.value;
        }
    });
}

onReady(initDropdown);
